import { admin2 } from '@/api/instance'

// admin.shopHomePageSummary.findOne
export const FindShopHomePageSummary = async ({
  shopId,
}) => {
  return await admin2({
    method: 'get',
    url: `/${shopId}/shopHomePageSummary`,
  })
}

// admin.shopHomePageSummary.findAppointmentUnit
export const FindShopHomePageStaffOverview = async ({
  shopId,
}) => {
  return await admin2({
    method: 'get',
    url: `/${shopId}/shopHomePageSummary/appointmentUnit`,
  })
}
